import { useEffect, useState, useContext } from 'react';

import { get as _get, debounce as _debounce } from 'lodash';

import DataContext from '../data/data-context';

const COLLAPSED_SIDE_PANEL = 30;
const EXPANDED_SIDE_PANEL = 265;

function useWindowSize () {
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const { systemSettings, sidenav } = useContext(DataContext);

    useEffect(() => {
        const copyright = 26;
        const header = _get(systemSettings, 'ui.messages.header') ? 20 : 0;
        const footer = _get(systemSettings, 'ui.messages.footer') ? 30 : 0;

        setHeight(Math.max(window.innerHeight - header - footer - copyright, 400));
        setWidth(Math.max(window.innerWidth - (sidenav.collapsed ? COLLAPSED_SIDE_PANEL : EXPANDED_SIDE_PANEL), 300));

        // add resize listener
        const resize = _debounce(() => {
            setWidth(Math.max(window.innerWidth - (sidenav.collapsed ? COLLAPSED_SIDE_PANEL : EXPANDED_SIDE_PANEL), 300));
            setHeight(Math.max(window.innerHeight - header - footer - copyright, 400));
        }, 111);
        window.addEventListener('resize', resize);
        return () => {
            resize.cancel();
            window.removeEventListener('resize', resize);
        };
    }, [sidenav.collapsed, systemSettings]);

    return { width, height };
}

export {
    useWindowSize as default,
};
